import { action, configure, observable, runInAction, computed, makeObservable } from "mobx";
import HomePageCMSModel from "./models/HomePageCMSModel";
import { SuburbModel } from "../../models";
import { Dealer } from "../../models";
import * as Request from "superagent";
import { ApiBasePath } from "../../utils/ApiBasePath";
import { HomePageVariant } from "./models/HomePageModel";
import CustomEvent from "custom-event";
import ReactDOMServer from "react-dom/server";
import { ModelWalkDetailedPricing } from "../ModelWalk/ModelWalkDetailedPricing";
import { PopupModalModel } from "../../models/PopupModalModel";

configure({ enforceActions: "always" });
export default class HomePageStore {
  constructor() {
    makeObservable(this);
  }
  @observable homePageContent?: HomePageCMSModel = new HomePageCMSModel();
  @observable designatedDealer?: Dealer;
  @observable savedSuburb?: SuburbModel;
  @observable isPopupEmailValid?: boolean = true;
  @observable popupEmailAddress?: string;
  @observable selectedTab?: string;
  @observable selectedTabTitle?: string;
  @observable homePageVariants?: HomePageVariant[] = [];

  @action fetchHomePageContentData = () => {
    this.homePageContent.response = window["homePageContent"];
    this.selectedTab = "suvVariants";
    this.selectedTabTitle =
      this.homePageContent.response.discoverAndBuild.suvTitle;
  };

  @action setSelectedTab = (target, isMobile = false) => {
    this.selectedTab = target.currentTarget.id;
    let indexOfTarget = target.currentTarget.id.indexOf("Variants");
    this.selectedTabTitle =
      this.homePageContent.response.discoverAndBuild[
        target.currentTarget.id.substring(0, indexOfTarget) + "Title"
      ];
    this.updateVariantsPricing();
    if (isMobile) {
      window.scrollTo(0, target.pageY);
    }
    const evt: CustomEvent = new CustomEvent("tabChanged");
    window.dispatchEvent(evt);
  };
  @action fetchSavedSuburb = () => {
    let defaultSuburb: SuburbModel = {
      name: "Sydney",
      postcode: "2000",
      fullName: "Sydney, 2000 NSW",
      state: "NSW",
    };

    var savedCookie = localStorage.getItem("suburb");
    var preselectedSuburb: SuburbModel;
    if (savedCookie) {
      preselectedSuburb = JSON.parse(savedCookie);
    } else {
      preselectedSuburb = defaultSuburb;
      const evt: CustomEvent = new CustomEvent("locationSelected", {
        detail: { suburb: preselectedSuburb },
      });
      window.dispatchEvent(evt);
    }

    this.savedSuburb = preselectedSuburb;
    this.updateVariantsPricing();
    this.fetchDesignatedDealer(preselectedSuburb.postcode);
  };

  @action fetchDesignatedDealer = (postCode: string = "2000") => {
    let url = `${ApiBasePath.dealers}?ActiveOnly=true&ByPma=true&Top=1&DepartmentName=Vehicle Sales&Postcode=${postCode}`;
    Request.get(url).then(
      (response) => {
        runInAction(() => {
          this.designatedDealer = response.body[0];
        });
      },
      (error) => {
        runInAction(() => {
          this.designatedDealer = null;
        });
      }
    );
  };

  @action setEmailValidity = (status: boolean) => {
    this.isPopupEmailValid = status;
  };

  @action setEmailAddress = (emailAddress: string) => {
    this.popupEmailAddress = emailAddress;
  };

  showDetailedPricing(variant: HomePageVariant): void {
    const modalContent = ReactDOMServer.renderToStaticMarkup(
      ModelWalkDetailedPricing(variant)
    );
    const content: PopupModalModel = {
      title: variant.name,
      text: modalContent,
    };
    const evt = new CustomEvent("showPopupModal", { detail: { content } });
    window.dispatchEvent(evt);
  }

  @action updateVariantsPricing() {
    this.homePageContent.response.discoverAndBuild[this.selectedTab].map(
      (variant: HomePageVariant, i) => {
        if (!this.savedSuburb.postcode) return;
        let postcode = this.savedSuburb.postcode.toString();

        if (postcode.length === 3) {
          postcode = "0".concat(postcode);
        }

        const url = `${ApiBasePath.pricing}/${postcode}/${variant.variantId}`;
        variant.price = null;
        Request.get(url).then(
          (response) => {
            runInAction(() => {
              if (response.body != null) {
                variant.price = response.body.rdp;
                variant.mlp = response.body.mlp;
                variant.rdp = response.body.rdp;
                const evt = new CustomEvent("priceUpdated", {
                  detail: {
                    variant: {
                      pimIdentifier: variant.pimIdentifier,
                      rdp: variant.price,
                    },
                  },
                });
                window.dispatchEvent(evt);
              }
            });
          },
          (error) => {
            runInAction(() => {});
          }
        );
      }
    );
    // });
  }
}
